export default __webpack_public_path__ + "static/fonts/BeVietnamPro-SemiBold.ttf";